
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Briefcase, GraduationCap, Heart } from "lucide-react";

const BackgroundCards = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
      <Card className="bg-gradient-to-br from-kaija-sage to-kaija-peach/70 border-none shadow-md">
        <CardContent className="pt-6">
          <div className="bg-white/80 w-14 h-14 rounded-full flex items-center justify-center mb-6 mx-auto shadow-sm">
            <Briefcase className="h-7 w-7 text-kaija-slate" />
          </div>
          <h3 className="text-xl font-medium mb-4 text-center">Töökogemus</h3>
          <p className="text-gray-700 leading-relaxed text-center">
            Üle 15 aasta juhtimiskogemust rahvusvahelises ettevõttes.
          </p>
        </CardContent>
      </Card>
      
      <Card className="bg-gradient-to-br from-kaija-sage to-kaija-peach/70 border-none shadow-md">
        <CardContent className="pt-6">
          <div className="bg-white/80 w-14 h-14 rounded-full flex items-center justify-center mb-6 mx-auto shadow-sm">
            <GraduationCap className="h-7 w-7 text-kaija-slate" />
          </div>
          <h3 className="text-xl font-medium mb-4 text-center">Haridus</h3>
          <p className="text-gray-700 text-center mb-3">
            Estonian Business School — International Business Administration, Bachelor
          </p>
        </CardContent>
      </Card>
      
      <Card className="bg-gradient-to-br from-kaija-sage to-kaija-peach/70 border-none shadow-md">
        <CardContent className="pt-6">
          <div className="bg-white/80 w-14 h-14 rounded-full flex items-center justify-center mb-6 mx-auto shadow-sm">
            <Heart className="h-7 w-7 text-kaija-slate" />
          </div>
          <h3 className="text-xl font-medium mb-4 text-center">Igapäevaelu</h3>
          <p className="text-gray-700 leading-relaxed text-center">
            Olen ema kahele teismelisele tütrele, armastan looduses viibimist ja pidevalt õppimist.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default BackgroundCards;
